export default "__VITE_ASSET__9ccc0b08__"